import { useEffect, useState } from 'react';
import { formatearFecha } from '@tanteo/compartido';
import {
  listarNegociosPlataforma,
  operacionesNegocio,
  type NegocioPlataforma,
  type OperacionNegocio,
} from '../../lib/api-panel';
import { Boton, Campo, CampoLista, CeldaPlata, EncabezadoTabla, Esqueleto, FilaTabla, Insignia, MensajeError, TablaAncha, Tarjeta, TextoAyuda } from '../../ui/base';

export function Operaciones() {
  const [negocios, setNegocios] = useState<NegocioPlataforma[]>([]);
  const [negocioId, setNegocioId] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [filas, setFilas] = useState<OperacionNegocio[] | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    listarNegociosPlataforma()
      .then(setNegocios)
      .catch(() => setNegocios([]));
  }, []);

  async function consultar() {
    if (!negocioId) return;
    setOcupado(true);
    setError('');
    try {
      setFilas(await operacionesNegocio(negocioId, desde || null, hasta || null));
    } catch (e) {
      setFilas([]);
      setError(e instanceof Error ? e.message : 'No pudimos consultar las operaciones.');
    } finally {
      setOcupado(false);
    }
  }

  return (
    <Tarjeta>
      <TextoAyuda>
        Sirve para responder <span className="font-semibold">"¿se registró el comprobante X?"</span>. Muestra
        consecutivo, fecha y estado; nunca montos ni datos del cliente. Cada consulta queda registrada en la auditoría
        con el negocio consultado.
      </TextoAyuda>

      <div className="mb-3 grid gap-2 sm:grid-cols-4">
        <CampoLista etiqueta="Negocio" value={negocioId} onChange={(e) => setNegocioId(e.target.value)} data-e2e="op-negocio">
          <option value="">Elige un negocio</option>
          {negocios.map((n) => (
            <option key={n.id} value={n.id}>
              {n.nombre}
            </option>
          ))}
        </CampoLista>
        <Campo etiqueta="Desde" type="date" value={desde} onChange={(e) => setDesde(e.target.value)} />
        <Campo etiqueta="Hasta" type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} />
        <div className="flex items-end">
          <Boton onClick={() => void consultar()} disabled={ocupado || !negocioId} data-e2e="op-consultar">
            {ocupado ? 'Consultando…' : 'Consultar'}
          </Boton>
        </div>
      </div>

      <MensajeError>{error}</MensajeError>

      {ocupado && filas === null ? (
        <Esqueleto lineas={6} />
      ) : filas === null ? (
        <p className="text-muted text-contenido">Elige un negocio y consulta.</p>
      ) : filas.length === 0 ? (
        <p className="text-muted text-contenido">Ese negocio no tiene comprobantes en el rango.</p>
      ) : (
        <TablaAncha>
            <EncabezadoTabla>
                <th className="py-2 pr-2">Consecutivo</th>
                <th className="py-2 pr-2">Fecha</th>
                <th className="py-2 pr-2 text-right">Líneas</th>
                <th className="py-2 pr-2">Origen</th>
                <th className="py-2 pr-2">Estado</th>
            </EncabezadoTabla>
            <tbody>
              {filas.map((f) => (
                <FilaTabla key={f.consecutivo} data-e2e="fila-operacion">
                  <td className="num py-2 pr-2 font-bold">{f.consecutivo}</td>
                  <td className="py-2 pr-2 text-contenido">{formatearFecha(f.fecha)}</td>
                  <CeldaPlata>{f.lineas}</CeldaPlata>
                  <td className="py-2 pr-2 text-contenido">{f.creadoVia}</td>
                  <td className="py-2 pr-2">
                    {f.estado === 'emitida' ? (
                      <Insignia tono="exito">Emitido</Insignia>
                    ) : (
                      <Insignia tono="peligro">Anulado</Insignia>
                    )}
                  </td>
                </FilaTabla>
              ))}
            </tbody>
          </TablaAncha>
      )}
    </Tarjeta>
  );
}
